import { Workout } from "@/models/workout"
import { startOfWeek } from "date-fns"

export type GroupedWorkouts = {
  groupedWorkouts: { [key: string]: Workout[] }
  sortedWeeks: string[]
}

export const groupWorkoutsByDate = (workouts: Workout[]): GroupedWorkouts => {
  // group workouts by week
  const groupedWorkouts = workouts.reduce((acc, workout) => {
    const date = new Date(workout.date)
    const startOfWeekDate = startOfWeek(date, { weekStartsOn: 1 })
    const startOfWeekKey = startOfWeekDate.toISOString()

    if (!acc[startOfWeekKey]) {
      acc[startOfWeekKey] = []
    }

    acc[startOfWeekKey].push(workout)

    return acc
  }, {} as { [key: string]: Workout[] })

  // sort grouped workouts by date in descending order
  const sortedWeeks = Object.keys(groupedWorkouts).sort(
    (a, b) => new Date(b).getTime() - new Date(a).getTime()
  )

  return { groupedWorkouts, sortedWeeks }
}
